import castArray from 'lodash/castArray';
import { Feature } from '@turf/helpers';

import { EDIT_SUGGESTION_TYPES, ITEM_TYPES } from '../constants/constants';
import { GeocodingFeature } from '../../types/mapbox-search-api-v1.types';

export const getItemTypes = (item): string[] | null =>
  item?.properties.place_type ? castArray(item.properties.place_type) : null;

export const getItemType = (item): string | undefined =>
  getItemTypes(item)?.[0];

export const getItemMetricParams = (item, params: { query? } = {}) => {
  const { query } = params;
  const { properties, geometry } = item;

  return {
    query,
    poi_category: properties?.poi_category,
    poi_address: properties?.description,
    coordinates: geometry?.coordinates,
  };
};

export const isPOIItem = (item) =>
  !!getItemTypes(item)?.includes(ITEM_TYPES.poi);

export const isAddressItem = (item) =>
  !!getItemTypes(item)?.includes(ITEM_TYPES.address);

export const isEditSuggestionType = (
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  value: any,
): value is EDIT_SUGGESTION_TYPES => {
  return value in EDIT_SUGGESTION_TYPES;
};

export const getItemEditSuggestionType = (
  item: Feature,
): EDIT_SUGGESTION_TYPES | undefined => {
  const itemType = getItemType(item);
  return isEditSuggestionType(itemType) ? itemType : undefined;
};

export const getItemDisplayName = (feature: GeocodingFeature): string => {
  const { matching_name, feature_name, place_type } = feature.properties;
  let displayName = feature_name;

  if (
    matching_name &&
    Array.isArray(place_type) &&
    place_type[0] === 'address'
  ) {
    displayName = matching_name;
  }

  return displayName;
};
